<template>
  <card-popup
    :value="!newsDialog"
    :loading="loading"
    :title="$t('components.news.title')"
    :items="news.slice(0, 3).map(({ id, name, primaryIndex }) => ({
      id,
      name,
      description: primaryIndex,
    }))"
    :viewMoreLink="news.length > 0"
    @click:item="(item) => viewDetails(news.findIndex((newsItem) => newsItem.id === item.id))"
    @click:more="viewDetails(0)"
  >
    <ModalDialog
      :loading="loading"
      :dialog="newsDialog && news.length > 0"
      @input="updateModalState"
    >
      <template slot="title">
        {{ $t('components.news.title') }}
      </template>

      <template slot="body">
        <v-carousel
          v-model="carouselModel"
          :continuous="false"
          :show-arrows="false"
          :light="true"
          hide-delimiter-background
          :hide-delimiters="$vuetify.breakpoint.mdAndUp"
          height="100%"
        >
          <v-carousel-item
            v-for="(newsItem, i) in news"
            :key="newsItem.id"
            :class="['scrollable', {
              'carousel-item-padded': !$vuetify.breakpoint.mdAndUp,
            }]"
          >
            <div class="title font-weight-light text-h5 break-word pt-5" >
              {{ news[i].name }}
            </div>

            <v-skeleton-loader
              v-if="newsDialog && loading"
              class="mt-5"
              height="100"
              type="paragraph"
            >
            </v-skeleton-loader>

            <div
             class="text-body-1 mt-5"
              v-if="!loading && !newsItem.resolution && newsItem.summary"
            >
              {{ newsItem.summary }}
            </div>

            <div
              class="text-body-2 mt-5"
              v-if="!loading && newsItem.resolution"
              v-html="parseResolution(newsItem.resolution, newsItem.id)"
            ></div>
          </v-carousel-item>
        </v-carousel>
      </template>

      <template slot="actions" v-if="$vuetify.breakpoint.mdAndUp">
        <div v-if="showPagination">
          <v-btn
            :disabled="carouselModel === 0"
            color="primary"
            text
            @click.stop="carouselModel --"
          >
            {{ $t('commons.previous') }}
          </v-btn>
          <span class="text-body-2">
            {{ $t('commons.pageOf', [(carouselModel + 1), news.length]) }}
          </span>
          <v-btn
            :disabled="carouselModel === (news.length - 1)"
            color="primary"
            text
            @click.stop="carouselModel ++"
          >
            {{ $t('commons.next') }}
          </v-btn>
        </div>
        <v-spacer />

        <v-switch
          v-if="showSwitch"
          v-model="displayWelcomeNewsModel"
          :label="$t('components.news.switch')"
          @click="changeValueSwitch()"
        ></v-switch>

      </template>
    </ModalDialog>
  </card-popup>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { STATUS as NEWS_STATUS } from '@/store/modules/news';
import ModalDialog from './ModalDialog.vue';
import CardPopup from './CardPopup.vue';

export default {
  props: {
    displayWelcomeNews: Boolean,
  },
  components: {
    ModalDialog, CardPopup,
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
    }),
    ...mapState({
      loading: ({ news: { status } }) => status === NEWS_STATUS.LOADING,
      news: ({ news: { news } }) => news,
    }),
  },
  data({ displayWelcomeNews }) {
    return {
      newsDialog: false,
      carouselModel: 0,
      displayWelcomeNewsModel: !displayWelcomeNews || false,
      showSwitch: false,
      showPagination: false,
    };
  },
  async created() {
    const id = parseInt(this.$getConst('news.idNews'), 10);
    await this.$store.dispatch('news/load', id);
    const publicada = this.news.findIndex((newItem) => newItem.statusId === 70);
    if (this.displayWelcomeNews && publicada >= 0) {
      this.viewDetails(publicada);
      this.showSwitch = true;
    } else if (this.displayWelcomeNews && publicada < 0) {
      this.updateModalState();
    } else {
      this.showSwitch = false;
      this.showPagination = true;
    }
  },
  mounted() {
    if (this.displayWelcomeNews) {
      this.newsDialog = true;
    }
  },
  watch: {
    carouselModel(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.viewDetails(newVal);
      }
      return newVal;
    },
  },
  methods: {
    viewDetails(index) {
      if (this.carouselModel !== index) {
        this.carouselModel = index;
      } else {
        if (this.loading) {
          this.$store.dispatch('news/cancel');
        }
        const newsItem = this.news[index];
        // if (!this.$store.getters['news/hasDetail'](newsItem.id)) {
        //   this.$store.dispatch('news/detail', newsItem.id);
        // }
        this.$store.dispatch('news/detail', newsItem.id);
        this.newsDialog = true;
      }
    },
    changeValueSwitch() {
      this.$store.dispatch('globalState/setRemoteItem', { key: 'display_welcome_news', value: !this.displayWelcomeNewsModel });
    },
    parseResolution(resolution, KiId) {
      const accessKey = (this.$store.getters['session/storage'] || {}).access_key;
      if (typeof resolution !== 'string' || accessKey == null) {
        return resolution;
      }
      return resolution
        .replace(/<img[^>]+src="([^">]+)"/g, (img, src) => {
          const NUMERIC_REGEXP = /[-]{0,1}[\d]*[.]{0,1}[\d]+/g;
          const numbers = src.match(NUMERIC_REGEXP);
          const urlImage = `/proxy-rest/knowledge-item/${KiId}/attachment/${numbers[1]}?accessKey=${accessKey}`;
          return img.replace(src, urlImage);
        });
    },
    updateModalState($event) {
      if ($event) {
        this.newsDialog = $event;
      } else {
        // CLIENT REQUEST
        // on modal close we must close the menu item so we keep the flag value to false
        // waiting for menu item closing
        setTimeout(() => {
          this.newsDialog = $event;
        }, 400);
        const videos2 = document.querySelectorAll('video');
        videos2.forEach((video) => {
          video.pause();
        });
        const iframes = document.querySelectorAll('iframe');
        iframes.forEach((iframe) => {
          iframe.remove();
        });
      }
      this.showSwitch = false;
      this.showPagination = true;
      this.$emit(`newsmodal:${$event ? 'open' : 'close'}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  /* check: https://vuetifyjs.com/en/components/carousels/ -> API -> SASS */
  $carousel-controls-size: 50px !default;

  .carousel-item-padded {
    padding-bottom: $carousel-controls-size;
  }

  .break-word {
    white-space: break-word;
  }
</style>

<style lang="scss">
  .v-carousel .scrollable .v-responsive__content {
    margin-top: 5px;
    overflow: auto;
    max-height: 100%;
  }
</style>
